import React, { useState } from 'react';
import {useNavigate} from 'react-router-dom';
import {Box} from '@mui/material';
import * as allConstants from '../../../../../constants/allConstants';
import AllInspectionsGrid from './allInspectionsGrid';
import ModalWrapper from '../../../../../pieces/modals/modalWrapper';
import DisplayListsPageWrapper from '../../../../wrappers/displayListsPageWrapper';
import {globalUseClasses} from '../../../../../styles/globalClasses';
import ListPageHeader from '../../../../../pieces/listPageHeader';
import usePagination from '../../../../../hooks/usePagination';
import mergeProps from 'merge-props';
import {useGridViewState} from '../../../../../hooks/useGridViewState';
import clsx from 'clsx';
import {jobFilters} from '../../../allJobs/jobExtendedFilters';
import {useSelector} from 'react-redux';
import {GridWithFilterWrapper, useFilter} from '../../../../../hooks/useFilter';
import useViewMenu, {MenuOption} from '../../../../../hooks/useViewMenu';
import {inspectionApiTypes} from './inspectionsGridOptions';
import {ListViewHeader} from '../../../components/listViewHeader';
import ManageCustomViews from '../../../components/manageCustomViews';

const AllInspectionsView = () => {

  console.log('inside AllInspectionsView');
  
  const [crudAction, setCrudAction] = useState('');
  const [isCategory, setIsCategory] = useState(false);
  const [customViewVisible, setCustomViewVisible] = useState(false);

  const viewController = useGridViewState();
  const navigate = useNavigate();
  const classes = {...globalUseClasses()};
  const pagination = usePagination();
  const user = useSelector(state=> state.user);

  const filterFields = jobFilters.getFilters(user, {module: allConstants.IPERMIT_MODULES.INSPECTION});

  const getMenuItems = ()=> {
    const items = [
      new MenuOption(inspectionApiTypes.pending, 'Pending Inspections'),
      new MenuOption(inspectionApiTypes.all, 'All Inspections'),
      new MenuOption(inspectionApiTypes.previous, 'Follow up'),
      new MenuOption(inspectionApiTypes.manual, 'Manually Ordered Inspections'),
      new MenuOption(inspectionApiTypes.hold, 'Hold'),
      new MenuOption(inspectionApiTypes.completed, 'Completed'),
      new MenuOption(inspectionApiTypes.failed, 'Failed'),
      new MenuOption(inspectionApiTypes.futureDate, 'Future Date'),
      new MenuOption(inspectionApiTypes.report, 'Report for Export'),
    ];

    return items;
  };
  const InspectionsGridEnum = getMenuItems();

  const menuController = useViewMenu({items: InspectionsGridEnum});

  const extendedFilters = useFilter({fields: filterFields, width: 230, collection: 'jobs'});

  const viewJobHandler = (id)=> {

    // Thanh 01/01/24
    //console.log('location');
    //console.log(location);

    const url = `${location.origin}${location.pathname}/${id}${location.search}&showSameAddressJobs=true`;
    
    //console.log('url => ' + url);
    
    window.open(url, '_blank');

    //navigate(`${id}${location.search}`);
  };

  const gridProps = {
    viewJobHandler: viewJobHandler,
    pagination: pagination,
    viewController: viewController
  };

  const handleClick = (event) => {
    menuController.setAnchorEl(event.currentTarget);
  };

  const showCustomView = (customView, crudAction, isCategory = false) => {

    setIsCategory(isCategory);
    setCrudAction(crudAction);
    customView.extendedFilter = JSON.stringify(extendedFilters.applyFilters);
  
    viewController.UpdateCustomViewFilterAndSorting(customView);
    setCustomViewVisible(true);
  };

  const setNewCustomViewId = (viewId) =>{
    viewController.setNewCustomViewId(viewId);
  }

  const changeCurrentView = (customView) => {
    if (customView) {
      if (customView?.extendedFilter != "") {
        extendedFilters.setApplyFilters(JSON.parse(customView.extendedFilter));
      }  
    }
    else {
      extendedFilters.setApplyFilters({});
    }

    viewController.changeCurrentView(customView);
  };

  const closeCustomView = () => {
    setCustomViewVisible(false);
  }

  const getHeaderComponent = ()=> {
    let title = menuController.title;
    if(pagination?.totalItemsCount || pagination.totalItemsCount === 0) {
      title = `${title} (${pagination.totalItemsCount})`;
    }
    return (
      <ListViewHeader title={title}
        gridEnum={InspectionsGridEnum}
        pagination={pagination}
        handleClick={handleClick}
        menuController={menuController}
        extendedFilters={extendedFilters}
        viewController={viewController}
        showCustomView={showCustomView}
        changeCurrentView = {changeCurrentView}
      />
    );
  };

  const headerComponent = <ListPageHeader headComponent = {getHeaderComponent()}
    totalItems={pagination.totalItemsCount}
    addHandler={()=>{navigate(allConstants.PATH.CREATE_JOB);}}
    showAddButton={false}
    showCustomView={true} 
  >
    {pagination.ItemsController}
  </ListPageHeader>;

  const currGridProps = mergeProps(gridProps, {gridType: InspectionsGridEnum[menuController.viewGrid].value});
  
  return (
    <>
      <Box className={clsx(classes.page)}>
        {customViewVisible && 
          <ModalWrapper
            open={true} modalName={'custom-view'}
            customStyle = {{minHeight: '50%'}}
            preventScroll={true}
            width={'50%'}
          >
            <ManageCustomViews closeCustomView = {closeCustomView} customViewData={viewController.customViewData}  
                      crudAction={crudAction} isCategory={isCategory} setNewCustomViewId={setNewCustomViewId} />
          </ModalWrapper>
        }
        <DisplayListsPageWrapper
          headerComponent={headerComponent}>

          <GridWithFilterWrapper show={extendedFilters.show} filterPanel={extendedFilters.filterPanel}>
            {
              <AllInspectionsGrid
                {...currGridProps}
                key={InspectionsGridEnum[menuController.viewGrid].value}
                additionalFilters={extendedFilters.applyFilters}
              />
            }
          </GridWithFilterWrapper>
          {pagination.PageController}
        </DisplayListsPageWrapper>

      </Box>

    </>


  );
};

export default AllInspectionsView;
